import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { executeReports } from "../../store/reports/actions";
export var useApiPostExecuteReports = function (trigger, reportBody) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            loadingExecuteReports: state.Reports.loadingExecuteReports,
            responseExecuteReports: (_a = state.Reports.responseExecuteReports) === null || _a === void 0 ? void 0 : _a.data,
            errorExecuteReports: state.Reports.errorExecuteReports,
        });
    }), loadingExecuteReports = _a.loadingExecuteReports, responseExecuteReports = _a.responseExecuteReports, errorExecuteReports = _a.errorExecuteReports;
    useEffect(function () {
        if (trigger) {
            dispatch(executeReports(reportBody));
        }
    }, [trigger, reportBody]);
    return {
        loadingExecuteReports: loadingExecuteReports,
        responseExecuteReports: responseExecuteReports,
        errorExecuteReports: errorExecuteReports,
    };
};
